module.exports = __webpack_public_path__ + "img/6.33f81240.png";